import {
  AlertOctagon,
  AlertTriangle,
  BanknoteX,
  BatteryLow,
  FileWarning,
  Fuel,
  Gauge,
  Info,
  LogIn,
  LogOut,
  PowerOff,
  Siren,
  TrendingDown,
  TrendingUp,
  Wrench,
  WifiOff,
  type LucideIcon,
} from 'lucide-react';
import { cn } from '@/lib/utils';
import type { AlertSeverity, AlertType } from '@/types/api';

export const ALERT_ICON: Record<AlertType, LucideIcon> = {
  GEOFENCE_ENTRY: LogIn,
  GEOFENCE_EXIT: LogOut,
  SPEEDING: Gauge,
  DEVICE_OFFLINE: WifiOff,
  LOW_BATTERY: BatteryLow,
  HARSH_BRAKING: TrendingDown,
  HARSH_ACCELERATION: TrendingUp,
  LOW_FUEL: Fuel,
  MAINTENANCE_DUE: Wrench,
  DOCUMENT_EXPIRY: FileWarning,
  SOS: Siren,
  PAYMENT_OVERDUE: BanknoteX,
  VEHICLE_IMMOBILISED: PowerOff,
};

const SEVERITY_STYLE: Record<AlertSeverity, { chip: string; icon: LucideIcon }> = {
  INFO: { chip: 'bg-info-soft text-info', icon: Info },
  WARNING: { chip: 'bg-idle-soft text-idle', icon: AlertTriangle },
  CRITICAL: { chip: 'bg-alert-soft text-alert', icon: AlertOctagon },
};

export function SeverityBadge({
  severity,
  className,
}: {
  severity: AlertSeverity;
  className?: string;
}) {
  const style = SEVERITY_STYLE[severity];
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-semibold capitalize',
        style.chip,
        className,
      )}
    >
      <style.icon className="size-3" strokeWidth={2.2} />
      {severity.toLowerCase()}
    </span>
  );
}

export function severityTone(severity: AlertSeverity) {
  return SEVERITY_STYLE[severity].chip;
}
